import gql from "graphql-tag";

export const TeamsQuery = gql`
  query teams {
    teams {
      id
      name
    }
  }
`;